import React, { useState } from 'react';
import { SearchBox } from '@fluentui/react';
import { makeSearchAllSitesUrl } from '../../../shared/config/config';

interface ISearchAllSitesProps {
    className: string;
}

const SearchAllSites: React.FC<ISearchAllSitesProps> = ({ className }) => {
    const [searchPhrase, setSearchPhrase] = useState('');

    const searchAllSites = (phrase: string) => {
        const url = makeSearchAllSitesUrl(phrase);
        window.location.href = url;
    };

    const onSearchPhraseChanged = (_event?: React.ChangeEvent<HTMLInputElement>, phrase?: string) => {
        setSearchPhrase(phrase || '');
    };

    return (
        <SearchBox
            className={`SearchAllSitesField ${className}`}
            placeholder="Search Spire"
            onSearch={searchAllSites}
            autoComplete="off"
            value={searchPhrase}
            onChange={onSearchPhraseChanged}
        />
    );
};

export default SearchAllSites;
